// src/components/LoadingScreen.js
import React from 'react';

const LoadingScreen = () => (
  <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
    <div className="text-center">
      {/* Sandvik Logo with loading animation */}
      <div className="relative mb-8">
        <div className="flex items-center justify-center mb-4">
          <img
            src="/sandvik_logotype_black_rgb300.png"
            alt="Sandvik Logo"
            className="w-16 h-16 object-contain animate-pulse"
          />
        </div>
        
        {/* Loading dots */}
        <div className="flex space-x-1 justify-center">
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
      </div>
      
      <div className="text-lg text-gray-700 mb-2">Loading your data</div>
      <div className="text-sm text-gray-500">Please wait while we fetch your reports...</div>
    </div>
  </div>
);

export default LoadingScreen;